function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import * as React from 'react';
import { localStorageAvailable } from '../../utils/utils';
var forceDebug = localStorageAvailable() && window.localStorage.getItem('DEBUG') != null;

var noop = function noop() {};

var noopLogger = {
  debug: noop,
  info: noop,
  warn: noop,
  error: noop
};
var LOG_LEVELS = ['debug', 'info', 'warn', 'error'];

function getAppender(name, logLevel) {
  var appender = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : console;
  var minLogLevelIdx = LOG_LEVELS.indexOf(logLevel);

  if (minLogLevelIdx === -1) {
    throw new Error("MUI: Log level ".concat(logLevel, " not recognized."));
  }

  var logger = LOG_LEVELS.reduce(function (loggerObj, method, idx) {
    if (idx >= minLogLevelIdx) {
      loggerObj[method] = function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var message = args[0],
            other = args.slice(1);
        appender[method].apply(appender, ["MUI: ".concat(name, " - ").concat(message)].concat(_toConsumableArray(other)));
      };
    } else {
      loggerObj[method] = noop;
    }

    return loggerObj;
  }, {});
  return logger;
}

export var useGridLoggerFactory = function useGridLoggerFactory(apiRef, props) {
  apiRef.current.getLogger = React.useCallback(function (name) {
    if (forceDebug) {
      return getAppender(name, 'debug', props.logger);
    }

    if (!props.logLevel) {
      return noopLogger;
    }

    return getAppender(name, props.logLevel.toString(), props.logger);
  }, [props.logLevel, props.logger]);
};